import { useState, useCallback, useRef } from "react";
import { Search } from "lucide-react";

import {
  InputGroup,
  InputGroupAddon,
  InputGroupInput,
} from "@/components/ui/input-group";

const UPDATE_TIMEOUT = 300;

const SearchInput = ({ query = "", placeholder = "", onUpdateQuery }) => {
  const [value, setValue] = useState(query);
  const timerRef = useRef(null);

  const debouncedUpdate = useCallback(
    nextValue => {
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => {
        onUpdateQuery(nextValue.trim());
      }, UPDATE_TIMEOUT);
    },
    [onUpdateQuery]
  );

  const handleChange = event => {
    setValue(event.target.value);
    debouncedUpdate(event.target.value);
  };

  return (
    <InputGroup className="tw:w-56">
      <InputGroupAddon>
        <Search />
      </InputGroupAddon>
      <InputGroupInput
        name="search"
        type="text"
        aria-label="Search"
        placeholder={placeholder || "Search..."}
        value={value}
        onChange={handleChange}
      />
    </InputGroup>
  );
};

export default SearchInput;
